// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__AJsX2","wrapperSkipPadding":"Layout_wrapperSkipPadding__-HzQr Layout_wrapper__AJsX2"};